import React, { useMemo } from 'react';
import { GenericListPage } from '../../components/generic';
import type { SpareRequisition } from '../../modules/spares/requisitions/useData';
import { useAccountVesselScope } from '../../hooks/useAccountVesselScope';
import { VesselSpareRequisitionsListProvider, useVesselSpareRequisitionsListData } from './useData';
import { createVesselSpareRequisitionsModuleConfig, getColumns, getToolbarIcon } from './vesselSpareRequisitionsModuleConfig';

const List: React.FC = () => {
  const vid = useAccountVesselScope();

  const bundle = useMemo(
    () => (vid != null && Number.isFinite(vid) ? createVesselSpareRequisitionsModuleConfig(vid) : null),
    [vid],
  );

  const config = useMemo(() => {
    if (!bundle) return null;
    return {
      ...bundle.moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions: bundle.getTableActions,
    };
  }, [bundle]);

  if (vid == null || !Number.isFinite(vid) || !config) {
    return <p className="text-sm text-red-600 dark:text-red-400">Invalid vessel.</p>;
  }

  return (
    <VesselSpareRequisitionsListProvider vesselId={vid}>
      <GenericListPage<SpareRequisition> useData={useVesselSpareRequisitionsListData} config={config} />
    </VesselSpareRequisitionsListProvider>
  );
};

export default List;
